<template>
  <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-title style="font-size: 2em">Errore</v-card-title>
          <v-form v-model="valid">
            <v-card-text>Non sei abilitato ad accedere alla pagina</v-card-text>
            <v-card-actions>
              <v-btn @click="$router.push('/')" >Torna al login</v-btn>
              </v-card-actions>
            
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
</template>

<script>
export default {
  data() {
    return {
      message: ""
    };
  },
  mounted() {}
};
</script>